import React from 'react';
import { Flex, Text, Heading } from '@chakra-ui/react';

function NoData({ data }) {


    return (

            <Flex
                p="10px"
                mt="20px"
                borderRadius="10px"
                width="80%"
                height='80%'
                justifyContent='center'
                alignItems='center'
                flexDirection="column"
            >
                <Heading >{data.heading}</Heading>
                <Text mt='25px'>{data.subtitle}</Text>
            </Flex>

    );
}

export default NoData;
